import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const FullWidthContainer = styled.div<{ isHidden?: boolean }>`
  width: 100%;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    ${(props) => props.isHidden && 'display: none;'}
  }
`;

export const Header = styled.div`
  background: none;
  width: 100%;
  display: flex;
  align-items: center;
  margin: 0;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    border-bottom: none;
    background: none;
  }
`;

export const HeaderTitle = styled.h1`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleDisplayLarge
      : textStyleCss(theme.atlas.typography.semantic.headingH2)}
  margin-top: 20px;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    color: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N800
        : props.theme.atlas.semantic.color.type.default};
    ${({ theme }) =>
      theme.isVaultVariant
        ? theme.newTypography.textStyleBodyLargeSemibold
        : textStyleCss(theme.atlas.typography.semantic.body)}
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  margin-bottom: 20px;
  margin-top: 40px;
`;
